<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">LRM Insurance Renewal Report</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="search">
      <div class="row align-items-center">
        <div class="col-md-1 fit-content">Year</div>
        <div class="col-md-2 fit-content pl-md-0">
          <select class="custom-select" v-model="year">
            <option value="">-- Please Select --</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div class="col-md-2 fit-content ml-md-4">Relationship</div>
        <div class="col-md-2 fit-content pl-md-0">
          <select class="custom-select" v-model="relationship">
            <option value="">-- Please Select --</option>
            <option value="E">E</option>
            <option value="S">S</option>
            <option value="C">C</option>
          </select>
        </div>
        <div class="col-md-1 ml-md-3">
          <button type="submit" class="btn btn-primary">Search</button>
        </div>
      </div>
    </form>
    <!-- /Form -->

    <!-- Pagination -->
    <div class="row mt-4 align-items-center" v-if="records && records.length">
      <div class="col-md-6">
        Show
        <select class="custom-select" v-model="paging.SizePerPage" style="width: 5em">
          <option v-for="item in paging.Sizes" v-bind:key="item" v-bind:value="item">
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-right">
        <form
          :action="backendUrl + '/InsuranceExcelReport/ExportLrmInsuranceRenewalExcel'"
          method="POST"
        >
          <input type="hidden" name="InsuranceYear" :value="yearForExcel" />
          <input
            type="hidden"
            name="DependentRelationship"
            :value="relationshipForExcel"
          />
          <button type="submit" class="btn btn-sm btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="records && records.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>

    <!-- Result -->
    <div class="row mt-2" v-if="records && records.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Policy Holder/Subsidiary Name</th>
                <th>Policy Number</th>
                <th class="text-center">Employee NRIC/<br />Passport No</th>
                <th class="text-center">Dependent NRIC/<br />Passport No</th>
                <th class="text-center">
                  Employee/Dependant Name<br />(as In NRIC/Passport)
                </th>
                <th>Marital Status</th>
                <th>Nationality</th>
                <th>Staff ID (Optional)</th>
                <th>Rel</th>
                <th>DOB</th>
                <th class="text-center">Age as of<br/>Effective Date</th>
                <th>Gender</th>
                <th>Action Type</th>
                <th>Effective Date</th>
                <th>Category</th>
                <th>Salary</th>
                <th>Corporate PA Plan</th>
                <th>Occupation Class</th>
                <th>Bank Code</th>
                <th>Bank Account number</th>
                <th>Email Address</th>
                <th>Mobile phone number</th>
                <th>Branch (Optional)</th>
                <th>Dept (Optional)</th>
                <th>Job Code (Optional)</th>
                <th class="text-center">Classification (Job Grade)<br />(Optional)</th>
                <th>Position Title (Optional)</th>
                <th class="text-center">Country of Work<br />(Outside of Malaysia)</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in records" :key="i">
                <td>{{ item.PolicyHolder }}</td>
                <td>{{ item.PolicyNumber }}</td>
                <td>{{ item.EmployeeNric }}</td>
                <td>{{ item.DependentNric }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ item.MaritalStatus }}</td>
                <td>{{ item.Nationality }}</td>
                <td>{{ item.StaffId }}</td>
                <td>{{ item.Rel }}</td>
                <td>{{ item.DobDisplay }}</td>
                <td>{{ item.AgeDisplay }}</td>
                <td>{{ item.Gender }}</td>
                <td>{{ item.ActionType }}</td>
                <td>{{ item.EffectiveDateDisplay }}</td>
                <td>{{ item.Category }}</td>
                <td>{{ item.SalaryDisplay }}</td>
                <td>{{ item.CorporatePaPlan }}</td>
                <td>{{ item.OccupationClass }}</td>
                <td>{{ item.BankName }}</td>
                <td>{{ item.BankAccountNumber }}</td>
                <td>{{ item.EmailAddress }}</td>
                <td>{{ item.MobilePhoneNumber }}</td>
                <td>{{ item.Branch }}</td>
                <td>{{ item.Dept }}</td>
                <td>{{ item.JobCode }}</td>
                <td>{{ item.Classification }}</td>
                <td>{{ item.PositionTitle }}</td>
                <td>{{ item.CountryOfWork }}</td>
                <td>{{ item.Remark }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Result -->

    <!-- Pagination -->
    <div class="row" v-if="records && records.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!-- /Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      companies: [],
      years: [],
      records: [],
      //search form
      year: "",
      relationship: "",
      //for excel
      yearForExcel: "",
      relationshipForExcel: "",
      noRecordText: config.NO_RECORD_TEXT,
      //pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    backendUrl() {
      return this.$backendUrl;
    },
  },

  watch: {
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.search();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    getYears() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    search() {
      //store variable for export excel
      this.yearForExcel = this.year;
      this.relationshipForExcel = this.relationship;
      //actual search
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
        InsuranceYear: this.year,
        DependentRelationship: this.relationship,
      };
      this.$store.state.isLoading = true;
      API.getLrmInsuranceRenewalReport(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.search();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.search();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.search();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.search();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.search();
    },
  },

  created() {
    if (this.role != "admin") {
      this.$router.replace({ name: "home" });
      return;
    }
    this.getYears();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}

.table {
  word-spacing: -3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/LrmInsuranceRenewalReport.vue